import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Input } from 'reactstrap';
import { useIntl } from 'react-intl';

import FileDetails from '../File/Details';
import FileTitle from '../File/Title';
import UploadFileProgress from '../Upload/FileProgress';

import { thumbnailProcessing } from '../../helpers/Files';

const UploadPageFileGridItem = ({
  uploader,
  file,
  isSelected,
  saving,
  switchSelectFile,
  handleRetryFile,
}) => {
  const intl = useIntl();

  if (!file.uuid) {
    return null;
  }

  const showProgress = !['completed', 'failed', 'error'].includes(file.uploadStatus);

  const isFailed = file.uploadStatus === 'failed';

  const handleRetryWrapper = () => {
    if (file.uploadStatus === 'failed') {
      handleRetryFile(file.id);
    }
  };

  return (
    <div
      id={file.uuid}
      className={classnames('grid-item col-sm-12 upload-page-grid-item', { error: isFailed })}
    >
      {!saving && (
        <Input
          type="checkbox"
          className="input-check check-l"
          id={`file-${file.uuid}`}
          checked={isSelected}
          onChange={() => {
            switchSelectFile(file.id);
          }}
        />
      )}
      <div id={`file-element-${file.uuid}`}>
        <div className="grid-item-img-wrapper">
          {((file.uploadStatus === 'completed' || file.uploadStatus === undefined) && file.urls) ? (
            <img
              className="grid-item-img"
              width="100%"
              src={file.urls.thumbnail}
              srcSet={`${file.urls.thumbnail} 1x, ${file.urls.thumbnailx2} 2x`}
              alt={file.display_name}
            />
          ) : (
            <img
              className="grid-item-img"
              width="100%"
              src={thumbnailProcessing}
              alt={file.display_name}
            />
          )}
        </div>
        <div className={classnames('grid-item-body', { 'has-folder': file.folder })}>
          {(showProgress && uploader) ? (
            <UploadFileProgress
              id={file.id}
              uploader={uploader}
            />
          ) : (
            <>
              <div className="grid-item-body-main">
                {file.folder && (
                <span className="uploaded-file-folder file-details">
                  {file.folder}
                </span>
                )}
                <FileTitle
                  className="grid-item-title"
                  file={file}
                />
                {(isFailed) && (
                <div className="error-details-wrapper">
                  <span className="error">
                    {intl.formatMessage({ defaultMessage: 'Upload failed. Please try again.' })}
                  </span>
                </div>
                )}
                {!isFailed && (
                <FileDetails
                  className="grid-item-details"
                  file={file}
                  showAccess={false}
                />
                )}
              </div>
              {isFailed && (
                <a
                  href="#retry"
                  className="retry-button"
                  title="Retry"
                  onClick={handleRetryWrapper}
                >
                  <i className="fas fa-redo" />
                </a>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

UploadPageFileGridItem.propTypes = {
  uploader: PropTypes.object,
  file: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  switchSelectFile: PropTypes.func,
  handleRetryFile: PropTypes.func.isRequired,
};

UploadPageFileGridItem.defaultProps = {
  uploader: null,
  switchSelectFile: () => {},
};

export default UploadPageFileGridItem;
